import React from 'react';
import { get } from 'lodash-es';
import { defineMessages } from 'react-intl';

import { emptyObject } from 'ui-components/default-props/empty';
import { BulkActions } from '../../../../enums/bulk-actions';
import { BulkConvertedDimensionsField } from '../../../converted-dimensions-input/bulk-converted-dimensions-field';

const messages = defineMessages({
  label: {
    description: 'bulkDimensionInput.label',
    defaultMessage: 'Size',
    id: 'wH4EjZ',
  },
  needsDimensionsError: {
    description: 'bulkDimensionInput.needsDimensionsError',
    defaultMessage: 'Length, width, and height are required',
    id: 'gmRG12',
  },
});

const getDimensions = (model) => get(model, 'shippingConfiguration.packages.0.dimensions', emptyObject);

export default {
  id: BulkActions.size.name,
  render: (onChange, model) => {
    const shippingConfiguration = get(model, 'shippingConfiguration');
    const firstPackage = get(shippingConfiguration, 'packages.0', emptyObject);
    const { dimensions = {} } = firstPackage;
    const updatePackageDimensions = (dims) => {
      onChange({
        ...model,
        shippingConfiguration: {
          ...shippingConfiguration,
          packages: [
            {
              ...firstPackage,
              dimensions: dims,
            },
          ],
        },
      });
    };
    return <BulkConvertedDimensionsField dimensions={dimensions} onChange={updatePackageDimensions} />;
  },
  getErrorsFromModel: (model) => {
    const { length, width, height } = getDimensions(model);
    const dimensions = [length, width, height];
    if (dimensions.some((dim) => dim === null || dim === undefined)) {
      return [
        {
          code: 'bulk:needs-dimensions',
          defaultMessage: messages.needsDimensionsError,
        },
      ];
    }
  },
};
